import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import {
  IconButton,
  MenuItem,
  Tooltip,
  Typography,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
  Card,
  Box,
} from "@mui/material";
import {
  StyledButton,
  StyledInputLabel,
  StyledSelect,
  StyledTextField,
  StyledTableCellHistory,
  StyledTableRowHistory,
  OutlinedIconFab,
  StyledMultilineTextField,
  StyledTableContainer,
} from "../StyledComponents";
import { toast } from "react-toastify";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import MicOffIcon from "@mui/icons-material/MicOff";
import ClearIcon from "@mui/icons-material/Clear";
import Icon from "../Utils/Icons";
import dayjs from "dayjs";
import { durationType } from "../initialData/initialData";
import {
  getHumanReadableDiffInPastDateWithAgo,
  getHumanReadableDurationInDate,
} from "../Utils/UtilsFunctions";
import DurationAutocompleteField from "./DurationAutocompleteField";
import {
  durationUnitMap,
  normalizeLegacyDuration,
  parseCombinedDuration,
  formatDurationTextForDisplay,
} from "./durationUtils";
import useSectionFieldLayout from "../config/hooks/useSectionFieldLayout";
import { FIELD_SET_IDS } from "../config/defaults/fieldLayoutUtils";
const FamilyHistory = ({
  familyHistoryData,
  setFamilyHistoryData,
  activeHistorySection,
  setActiveHistorySection,
  startRecording,
  stopRecording,
  isAiEnabled,
  fieldLayout: fieldLayoutProp,
}) => {
  const fieldLayout = useSectionFieldLayout(
    fieldLayoutProp,
    FIELD_SET_IDS.familyHistory,
  );
  console.log("Family History called", familyHistoryData);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [autocompleteData, setAutoCompleteData] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [suggestApiCalled, setSuggestApiCalled] = useState(false);
  const [debounceFunctionCalledCondition, setDebounceFunctionCalledCondition] =
    useState(false);
  const { transcript, resetTranscript } = useSpeechRecognition();
  const [listeningOn, setListeningOn] = useState(false);
  const [familyHistoryVars, setFamilyHistoryVars] = useState({
    relation: "",
    condition: "",
    onSetAge: "",
    deceased: false,
    clinical_note: "",
    onset_duration: "",
    abatement_duration: "",
  });
  const [termSelectedOrAdded, setTermSelectedOrAdded] = useState(false);
  const [conditionName, setConditionName] = useState("");
  const [error, setError] = useState("");
  const [familyHistoryEditIndex, setFamilyHistoryEditIndex] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const hasPendingDurationSelection = (durationValue) =>
    /^\d+$/.test(String(durationValue || "").trim());
  const [clinicalNotesListening, setClinicalNotesListening] = useState(false);
  const [mouseDownOnOption, setMouseDownOnOption] = useState(false);

  const debounceTimeout = useRef(null); // Use useRef to persist timeout
  const skipEffect = useRef(false);
  const optionChosen = useRef(false);

  useEffect(() => {
    setAuthToken(sessionStorage.getItem("accessToken"));
  }, [sessionStorage.getItem("accessToken")]);

  useEffect(() => {
    // alert(`DH ${activeHistorySection}`);
    if (activeHistorySection == "Family History") {
      let timerId;

      timerId = setTimeout(() => {
        setConditionName(transcript);
      }, 3000);

      return () => {
        clearTimeout(timerId);
      };
    }
  }, [transcript]);
  useEffect(() => {
    if (skipEffect.current) {
      skipEffect.current = false; // reset after skipping
      return;
    }
    // Call the API with the debounced function when conditionName changes

    let timerOut = setTimeout(() => {
      if (conditionName.trim() !== "") {
        debouncedConditionFilterCall(conditionName.toLowerCase());
      }
    }, 500);
    return () => clearInterval(timerOut);
  }, [conditionName]);

  const startListening = (key) => {
    // alert("MH SL");
    if (transcript) {
      resetTranscript();
    }
    setActiveHistorySection("Family History");
    SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
    setListeningOn(true);
    if (key == "condition") {
      setClinicalNotesListening(false);
    } else {
      setClinicalNotesListening(true);
    }
  };
  const debouncedConditionFilterCall = async (medicine) => {
    console.log("Debounce function called");
    let semanticTagForConditionSearch = "finding++disorder";
    const postBody = {
      term: medicine,
      state: "active",
      semantictag: semanticTagForConditionSearch,
      acceptability: "synonyms",
      returnlimit: "100",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (conditionName.length > 1) {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
          postBody,
          { headers: headers }
        );
        if (response) {
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            const dataToProcess =
              response.data.data.length > 300
                ? response.data.data.slice(0, 300)
                : response.data.data;

            const filteredData = dataToProcess.map((medicineItem) => {
              return {
                term: medicineItem.term,
                id: medicineItem.conceptId,
              };
            });
            console.log("Filtered Medicine Data", filteredData);
            setAutoCompleteData(filteredData);
            setFilteredOptions(filteredData);
          } else {
            try {
              const response = await axios.post(
                `${REACT_APP_BACKEND_ROUTE_URL}snomed/suggest/`,
                postBody,
                { headers: headers }
              );
              if (response) {
                console.log("Suggest Response", response);
                if (
                  response.data.status === "Success" &&
                  response.data.data.length > 0
                ) {
                  setSuggestApiCalled(true);
                  const dataToProcess =
                    response.data.data.length > 300
                      ? response.data.data.slice(0, 300)
                      : response.data.data;
                  setAutoCompleteData(dataToProcess);
                  setFilteredOptions(dataToProcess);
                  // setSelectedFromSuggestion(true);
                } else {
                  // setSelectedFromSuggestion(true);

                  setAutoCompleteData([]);
                  setFilteredOptions([]);
                }
              }
            } catch (err) {
              console.log(err);
              toast.error(err);
            }
          }
          setDebounceFunctionCalledCondition(true);
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };
  const validateFields = () => {
    const errors = {};

    if (
      fieldLayout.isFieldVisible("clinical_note", familyHistoryVars) &&
      fieldLayout.isFieldRequired("clinical_note", familyHistoryVars) &&
      !familyHistoryVars.clinical_note?.trim()
    ) {
      errors.clinical_note = fieldLayout.getValidationMessage(
        "clinical_note",
        "Clinical Notes is a mandatory field.",
      );
    }

    if (
      fieldLayout.isFieldVisible("onSetAge", familyHistoryVars) &&
      fieldLayout.isFieldRequired("onSetAge", familyHistoryVars) &&
      !familyHistoryVars.onSetAge
    ) {
      errors.onSetAge = fieldLayout.getValidationMessage(
        "onSetAge",
        "On Set Age is a mandatory field.",
      );
    }

    if (
      fieldLayout.isFieldVisible("deceased", familyHistoryVars) &&
      fieldLayout.isFieldRequired("deceased", familyHistoryVars) &&
      familyHistoryVars.deceased !== true &&
      familyHistoryVars.deceased !== false &&
      familyHistoryVars.deceased !== "N/A"
    ) {
      errors.deceased = fieldLayout.getValidationMessage(
        "deceased",
        "Deceased is a mandatory field.",
      );
    }

    if (
      fieldLayout.isFieldVisible("onset_duration", familyHistoryVars) &&
      fieldLayout.isFieldRequired("onset_duration", familyHistoryVars) &&
      !familyHistoryVars.onset_duration
    ) {
      errors.onset_duration = fieldLayout.getValidationMessage(
        "onset_duration",
        "Duration is a mandatory field.",
      );
    } else if (
      fieldLayout.isFieldVisible("onset_duration", familyHistoryVars) &&
      hasPendingDurationSelection(familyHistoryVars.onset_duration)
    ) {
      errors.onset_duration = "Please select a duration option.";
    }

    if (
      fieldLayout.isFieldVisible("abatement_duration", familyHistoryVars) &&
      fieldLayout.isFieldRequired("abatement_duration", familyHistoryVars) &&
      !familyHistoryVars.abatement_duration
    ) {
      errors.abatement_duration = fieldLayout.getValidationMessage(
        "abatement_duration",
        "Condition Duration is a mandatory field.",
      );
    } else if (
      fieldLayout.isFieldVisible("abatement_duration", familyHistoryVars) &&
      hasPendingDurationSelection(familyHistoryVars.abatement_duration)
    ) {
      errors.abatement_duration = "Please select a duration option.";
    }

    setValidationErrors(errors);

    return Object.keys(errors).length === 0;
  };
  const handleAddRow = async () => {
    if (!validateFields()) {
      return;
    }
    if (familyHistoryVars.condition || conditionName.length > 0) {
      // Store the updated state in a local variable
      let newDetails,
        updatedFound = {},
        updatedSelectedOptiondetsils = {},
        foundData = false;

      if (!optionChosen.current) {
        const postBody = {
          term: conditionName,
          state: "active",
          semantictag: "finding++disorder",
          acceptability: "synonyms",
          returnlimit: "100",
          refsetid: null,
          parentid: null,
          excludeparentconcept: false,
          fullconcept: true,
        };

        try {
          if (conditionName.length > 1) {
            const response = await axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
              postBody,
              { headers: headers }
            );
            if (response) {
              console.log("Snomed Response", response);
              if (
                response.data.status === "Success" &&
                response.data.data.length > 0
              ) {
                foundData = response.data.data.find(
                  (d) => d.term === conditionName
                );
                console.log("Found Data", foundData);
                if (foundData) {
                  updatedFound = {
                    ...foundData,
                    found: true,
                    id: foundData.conceptId,
                  };
                } else {
                  updatedSelectedOptiondetsils = {
                    hierarchy: null,
                    isPreferredTerm: null,
                    conceptState: null,
                    conceptFsn: conditionName,
                    definitionStatus: null,
                    conceptId: null,
                    languageCode: "en",
                    typeId: null,
                    term: conditionName,
                    caseSignificanceId: "CASE_INSENSITIVE",
                    id: null,
                    effectiveTime: null,
                    activeStatus: null,
                    moduleId: null,
                  };
                }
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: conditionName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: conditionName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }

              if (foundData) {
                console.log("updatedFound", updatedFound);
                newDetails = {
                  ...familyHistoryVars,
                  condition: updatedFound.term,
                  id: updatedFound.id,
                };
              } else {
                console.log(
                  "updatedSelectedOptiondetsils",
                  updatedSelectedOptiondetsils
                );
                newDetails = {
                  ...familyHistoryVars,
                  condition: updatedSelectedOptiondetsils.term,
                  id: updatedSelectedOptiondetsils.id,
                };
              }
            } else {
              newDetails = {
                ...familyHistoryVars,
                condition: conditionName,
                id: null,
              };
            }
          }
        } catch (err) {
          console.log(err);
          // toast.error(err);
          newDetails = {
            ...familyHistoryVars,
            condition: conditionName,
            id: null,
          };
        }
      } else {
        newDetails = { ...familyHistoryVars };
      }

      const newRow = {
        relation: newDetails.relation,
        condition: newDetails.condition,
        onSetAge: newDetails.onSetAge,
        deceased: newDetails.deceased,
        clinical_note: newDetails?.clinical_note,
        onset_duration: normalizeLegacyDuration(
          newDetails?.onset_duration,
          newDetails?.onset_duration,
          newDetails?.onset_duration_type
        ),
        abatement_duration: normalizeLegacyDuration(
          newDetails?.abatement_duration,
          newDetails?.abatement_duration,
          newDetails?.abatement_duration_type
        ),
        onset_datetime: newDetails?.onset_datetime?.format("YYYY-MM-DD"),       // ADD
        abatement_datetime: newDetails?.abatement_datetime?.format("YYYY-MM-DD"),
      };

      // Update family history rows by adding the new row

      const updatedRows = [...familyHistoryData["new"], newRow];

      setFamilyHistoryData({
        ...familyHistoryData,
        new: updatedRows,
      });
      // Reset family history variables and clear error
      setFamilyHistoryVars({
        ...familyHistoryVars,
        relation: "",
        condition: "",
        onSetAge: "",
        clinical_note: "",
        deceased: false,
        onset_duration: "",
        abatement_duration: "",
      });
      setConditionName("");
      setError("");
      setValidationErrors({});
      setDebounceFunctionCalledCondition(false);
      setTermSelectedOrAdded(false);
      optionChosen.current = false;
      setFilteredOptions([]);
    } else {
      // Set error message if any field is missing
      setError("Condition Name field is required");
    }
  };
  const handleFamilyHistoryEditClick = (row, rowIndex) => {
    setConditionName(row.condition);
    setFamilyHistoryVars({
      relation: row.relation,
      onSetAge: row.onSetAge,
      deceased: row.deceased,
      clinical_note: row?.clinical_note,
      condition: "",
      onset_duration: normalizeLegacyDuration(
        row?.onset_duration,
        row?.onset_duration,
        row?.onset_duration_type
      ),
      abatement_duration: normalizeLegacyDuration(
        row?.abatement_duration,
        row?.abatement_duration,
        row?.abatement_duration_type
      ),
      onset_datetime: row?.onset_datetime ? dayjs(row.onset_datetime) : null,
      abatement_datetime: row?.abatement_datetime ? dayjs(row.abatement_datetime) : null,
    });
    setFamilyHistoryEditIndex(rowIndex);
  };
  const handleFamilyHistoryUpdate = async () => {
    if (!validateFields()) {
      return;
    }
    if (familyHistoryVars.condition || conditionName.length > 0) {
      // Store the updated state in a local variable

      let newDetails,
        updatedFound = {},
        updatedSelectedOptiondetsils = {},
        foundData = false;

      if (!optionChosen.current) {
        const postBody = {
          term: conditionName,
          state: "active",
          semantictag: "finding++disorder",
          acceptability: "synonyms",
          returnlimit: "100",
          refsetid: null,
          parentid: null,
          excludeparentconcept: false,
          fullconcept: true,
        };

        try {
          if (conditionName.length > 1) {
            const response = await axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
              postBody,
              { headers: headers }
            );
            if (response) {
              console.log("Snomed Response", response);
              if (
                response.data.status === "Success" &&
                response.data.data.length > 0
              ) {
                foundData = response.data.data.find(
                  (d) => d.term === conditionName
                );
                console.log("Found Data", foundData);
                if (foundData) {
                  updatedFound = {
                    ...foundData,
                    found: true,
                    id: foundData.conceptId,
                  };
                } else {
                  updatedSelectedOptiondetsils = {
                    hierarchy: null,
                    isPreferredTerm: null,
                    conceptState: null,
                    conceptFsn: conditionName,
                    definitionStatus: null,
                    conceptId: null,
                    languageCode: "en",
                    typeId: null,
                    term: conditionName,
                    caseSignificanceId: "CASE_INSENSITIVE",
                    id: null,
                    effectiveTime: null,
                    activeStatus: null,
                    moduleId: null,
                  };
                }
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: conditionName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: conditionName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }

              if (foundData) {
                console.log("updatedFound", updatedFound);
                newDetails = {
                  ...familyHistoryVars,
                  condition: updatedFound.term,
                  id: updatedFound.id,
                };
              } else {
                console.log(
                  "updatedSelectedOptiondetsils",
                  updatedSelectedOptiondetsils
                );
                newDetails = {
                  ...familyHistoryVars,
                  condition: updatedSelectedOptiondetsils.term,
                  id: updatedSelectedOptiondetsils.id,
                };
              }
            } else {
              newDetails = {
                ...familyHistoryVars,
                condition: conditionName,
                id: null,
              };
            }
          }
        } catch (err) {
          console.log(err);
          // toast.error(err);
          newDetails = {
            ...familyHistoryVars,
            condition: conditionName,
            id: null,
          };
        }
      } else {
        newDetails = { ...familyHistoryVars };
      }

      const updatedRow = {
        relation: newDetails.relation,
        condition: newDetails.condition,
        onSetAge: newDetails.onSetAge,
        deceased: newDetails.deceased,
        clinical_note: newDetails?.clinical_note,
        onset_duration: normalizeLegacyDuration(
          newDetails?.onset_duration,
          newDetails?.onset_duration,
          newDetails?.onset_duration_type
        ),
        abatement_duration: normalizeLegacyDuration(
          newDetails?.abatement_duration,
          newDetails?.abatement_duration,
          newDetails?.abatement_duration_type
        ),
        onset_datetime: newDetails?.onset_datetime?.format("YYYY-MM-DD"),       // ADD
        abatement_datetime: newDetails?.abatement_datetime?.format("YYYY-MM-DD"),
        source: undefined,
      };

      // Update family history rows by adding the new row

      const updatedFamilyHistory = familyHistoryData["new"].map(
        (row, index) => {
          if (index === familyHistoryEditIndex) {
            return updatedRow;
          } else {
            return row;
          }
        }
      );
      setFamilyHistoryData({
        ...familyHistoryData,
        new: updatedFamilyHistory,
      });
      // Reset family history variables and clear error
      setFamilyHistoryVars({
        ...familyHistoryVars,
        relation: "",
        condition: "",
        onSetAge: "",
        clinical_note: "",
        deceased: false,
        onset_duration: "",
        abatement_duration: "",
      });
      setFamilyHistoryEditIndex(null);
      setError("");
      setValidationErrors({});
      setConditionName("");
      setDebounceFunctionCalledCondition(false);
      setTermSelectedOrAdded(false);
      setFilteredOptions([]);
      optionChosen.current = false;
    } else {
      // Set error message if any field is missing
      setError("Condition Name field is required");
    }
  };
  const handleFamilyHistoryDelete = (rowIndex) => {
    // Filter out the row at the specified index
    const updatedFamilyHistory = familyHistoryData["new"].filter(
      (row, index) => index !== rowIndex
    );
    // Update the state with the filtered array
    setFamilyHistoryData({
      ...familyHistoryData,
      new: updatedFamilyHistory,
    });
  };
  const calculateOnsetDate = (duration, type) => {
    if (duration === null || duration === undefined || isNaN(parseInt(duration))) return null;
    const today = dayjs();
    return today.subtract(duration, durationUnitMap[type]);
  };
  const calculateAbatementDate = (onset_datetime, duration, type) => {
    if (duration === null || duration === undefined || isNaN(parseInt(duration)) || !onset_datetime) return null;
    return dayjs(onset_datetime).add(duration, durationUnitMap[type]);
  };

  const handleChangeFamilyHistory = (field, value) => {
    if (field == "condition") {
      setAutoCompleteData([]);
      setFilteredOptions([]);
      setTermSelectedOrAdded(true);
    }

    let newDetails = {
      ...familyHistoryVars,
      [field]: field == "condition" ? value : value,
    };

    if (field === "onset_duration") {
      const onsetParsed = parseCombinedDuration(newDetails.onset_duration);
      const calculatedDate =
        onsetParsed.value && onsetParsed.unit
          ? calculateOnsetDate(parseInt(onsetParsed.value, 10), onsetParsed.unit)
          : null;
      newDetails.onset_datetime = calculatedDate ?? null;
    } else if (field === "onset_duration") {
      newDetails.onset_datetime = null;
    }

    if (
      field === "abatement_duration"
    ) {
      const abatementParsed = parseCombinedDuration(newDetails.abatement_duration);
      const calculatedDate = calculateAbatementDate(
        newDetails.onset_datetime,
        abatementParsed.value ? parseInt(abatementParsed.value, 10) : null,
        abatementParsed.unit
      );
      newDetails.abatement_datetime = calculatedDate ?? null;
    } else if (field === "abatement_duration") {
      newDetails.abatement_datetime = null;
    }

    setFamilyHistoryVars(newDetails);
  };
  const handleClearConditionName = () => {
    setError("");
    setConditionName("");
    resetTranscript();
    setFamilyHistoryVars({
      ...familyHistoryVars,
      condition: "", // Use computed property name to set the field dynamically
    });
    setTermSelectedOrAdded(false);
    setFilteredOptions([]);
    setDebounceFunctionCalledCondition(false);
    // setMedicineList([])
  };
  const handleAddOption = async (term) => {
    const postBody = {
      term: term,
      state: "active",
      semantictag: "finding++disorder",
      acceptability: "synonyms",
      returnlimit: "100",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (conditionName.length > 1) {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
          postBody,
          { headers: headers }
        );
        if (response) {
          let updatedFound = {},
            updatedSelectedOptiondetsils = {},
            foundData = false;
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            foundData = response.data.data.find((d) => d.term === term);
            console.log("Found Data", foundData);
            if (foundData) {
              updatedFound = {
                ...foundData,
                found: true,
                id: foundData.conceptId,
              };
            } else {
              updatedSelectedOptiondetsils = {
                hierarchy: null,
                isPreferredTerm: null,
                conceptState: null,
                conceptFsn: term,
                definitionStatus: null,
                conceptId: null,
                languageCode: "en",
                typeId: null,
                term: term,
                caseSignificanceId: "CASE_INSENSITIVE",
                id: null,
                effectiveTime: null,
                activeStatus: null,
                moduleId: null,
              };
            }
          } else {
            updatedSelectedOptiondetsils = {
              hierarchy: null,
              isPreferredTerm: null,
              conceptState: null,
              conceptFsn: term,
              definitionStatus: null,
              conceptId: null,
              languageCode: "en",
              typeId: null,
              term: term,
              caseSignificanceId: "CASE_INSENSITIVE",
              id: null,
              effectiveTime: null,
              activeStatus: null,
              moduleId: null,
            };
          }

          setAutoCompleteData([]);
          setFilteredOptions([]);
          setSuggestApiCalled(false);
          setDebounceFunctionCalledCondition(true);
          if (foundData) {
            handleChangeFamilyHistory("condition", updatedFound.term);
          } else {
            handleChangeFamilyHistory(
              "condition",
              updatedSelectedOptiondetsils.term
            );
          }
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };
  const handleClearClinicalNotes = () => {
    setError("");

    resetTranscript();
    setFamilyHistoryVars({
      ...familyHistoryVars,
      clinical_note: "", // Use computed property name to set the field dynamically
    });
  };
  const handleConditionTyped = (value) => {
    setConditionName(value);

    // if (debounceTimeout.current) {
    //   clearTimeout(debounceTimeout.current); // Clear previous timeout
    // }

    // debounceTimeout.current = setTimeout(() => {
    //   handleAddOption(value); // Only triggers after user stops typing
    // }, 500); // Adjust delay as needed
  };

  const renderFamilyTableCell = (column, row, { isPrev = false, isNew = false } = {}) => {
    switch (column.key) {
      case "relation":
        return row?.relation || "-";
      case "condition":
        return isNew ? (
          <>
            {row?.condition}
            {row?.source === "voice" && !row.id && (
              <Tooltip title="Machine-interpreted text — please verify before confirming">
                <span className="missing-id-warning">⚠️</span>
              </Tooltip>
            )}
          </>
        ) : (
          row?.condition || "-"
        );
      case "onSetAge":
        return isNew
          ? isNaN(row?.onSetAge)
            ? "-"
            : row?.onSetAge
              ? row?.onSetAge
              : "-"
          : row?.onSetAge || "-";
      case "deceased":
        return row?.deceased === "N/A" ? "N/A" : row?.deceased ? "Yes" : "No";
      case "clinical_note":
        return row?.clinical_note ? row.clinical_note : "-";
      case "onset_duration":
        if (isPrev) {
          return formatDurationTextForDisplay(
            row?.onset_datetime
              ? getHumanReadableDiffInPastDateWithAgo(row?.onset_datetime, row)
              : normalizeLegacyDuration(
                    row?.onset_duration,
                    row?.onset_duration,
                    row?.onset_duration_type,
                  )
                ? `${normalizeLegacyDuration(
                    row?.onset_duration,
                    row?.onset_duration,
                    row?.onset_duration_type,
                  )} ago`
                : "-",
          );
        }
        return formatDurationTextForDisplay(
          normalizeLegacyDuration(
            row?.onset_duration,
            row?.onset_duration,
            row?.onset_duration_type,
          )
            ? `${normalizeLegacyDuration(
                row?.onset_duration,
                row?.onset_duration,
                row?.onset_duration_type,
              )} ago`
            : "-",
        );
      case "abatement_duration":
        if (isPrev) {
          return formatDurationTextForDisplay(
            row?.abatement_datetime
              ? getHumanReadableDurationInDate(
                  row?.onset_datetime,
                  row?.abatement_datetime,
                  row,
                )
              : normalizeLegacyDuration(
                  row?.abatement_duration,
                  row?.abatement_duration,
                  row?.abatement_duration_type,
                ) || "-",
          );
        }
        return (
          formatDurationTextForDisplay(
            normalizeLegacyDuration(
              row?.abatement_duration,
              row?.abatement_duration,
              row?.abatement_duration_type,
            ),
          ) || "-"
        );
      default:
        return row?.[column.key] ?? "-";
    }
  };

  return (
    <Card
      sx={{
        borderRadius: "10px",
        boxShadow: "0 4px 4px 0 #C7C7CC inset",
        backgroundColor: "#FFF",
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{ margin: "5px 0px", display: "flex", alignItems: "center" }}
      >
        {fieldLayout.isFieldVisible("condition", familyHistoryVars) && (
        <Grid item {...fieldLayout.getFieldGrid("condition", { xs: 11, sm: 11 })} sx={{ margin: "5px 0px" }}>
          <StyledTextField
            fullWidth
            label={fieldLayout.getFieldLabel("condition", "Condition", familyHistoryVars)}
            value={
              // familyHistoryVars.condition !== ""
              //   ? familyHistoryVars.condition
              //   :
              conditionName
            }
            onChange={(e) => {
              // if (!familyHistoryVars.condition) {
              //   setConditionName(e.target.value);
              // }
              handleConditionTyped(e.target.value);
            }}
            onBlur={() => {
              setTimeout(() => {
                const shouldClear = !mouseDownOnOption;

                if (shouldClear) {
                  // setIsFocused(false);
                  setFilteredOptions([]);
                  setDebounceFunctionCalledCondition(false);
                  setTermSelectedOrAdded(false);
                }

                setMouseDownOnOption(false);
              }, 100);
            }}
            onFocus={() => {
              // setIsFocused(true);
              if (conditionName.trim() !== "") {
                debouncedConditionFilterCall(conditionName.toLowerCase()); // re-trigger filtering
              }
            }}
            InputProps={{
              endAdornment: (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ marginRight: "5px" }}>
                    <Tooltip title="Clear">
                      <OutlinedIconFab
                        size="small"
                        variant="contained"
                        onClick={handleClearConditionName}
                      >
                        <Icon name="clearTextField" size={32} />
                      </OutlinedIconFab>
                    </Tooltip>
                  </div>
                  {/* {!termSelectedOrAdded && (
                    <Tooltip title="Add" style={{ marginRight: "5px" }}>
                      <OutlinedIconFab
                        size="small"
                        variant="contained"
                        onClick={handleAddOption}
                      >
                        <AddIcon />
                      </OutlinedIconFab>
                    </Tooltip>
                  )} */}
                  <>
                    {isAiEnabled &&
                      (listeningOn === false ? (
                        <Tooltip title="Start Listening">
                          <OutlinedIconFab
                            // onClick={() => startListening("condition")}
                            onClick={() => {
                              startRecording();
                              setListeningOn(true);
                            }}
                            variant="contained"
                            color="defaultColor"
                            size="small"
                          >
                            <Icon name="micNotInUse" size={32} />
                          </OutlinedIconFab>
                        </Tooltip>
                      ) : listeningOn === true &&
                        clinicalNotesListening === true ? (
                        <Tooltip title="Start Listening">
                          <OutlinedIconFab
                            // onClick={() => startListening("condition")}
                            onClick={() => {
                              startRecording();
                              setListeningOn(true);
                            }}
                            variant="contained"
                            color="default"
                            size="small"
                          >
                            <Icon name="micNotInUse" size={32} />
                          </OutlinedIconFab>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Stop Listening">
                          <OutlinedIconFab
                            onClick={() => {
                              // SpeechRecognition.stopListening();
                              stopRecording("Family History");
                              setListeningOn(false);
                            }}
                            variant="outlined"
                            color="default"
                            size="small"
                          >
                            <Icon name="micInUse" size={32} />
                          </OutlinedIconFab>
                        </Tooltip>
                      ))}
                  </>
                </div>
              ),
            }}
          />
          {filteredOptions.length > 0 ? (
            <div
              style={{
                backgroundColor: "#f5f5f5",
                borderRadius: "10px",
                padding: "20px",
                maxHeight: "200px", // Set your desired maximum height here
                overflowY: "auto", // Add vertical scrolling
              }}
            >
              {/* Display filtered medicines */}
              {suggestApiCalled && (
                <div style={{ color: "red" }}>
                  No Exact Matches found ! You can search for the following
                  Suggestions.
                </div>
              )}

              <>
                {filteredOptions.map((op) => (
                  <div key={op}>
                    {
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {op.added ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <StyledButton
                              color="success"
                              sx={{
                                textAlign: "left",
                                justifyContent: "flex-start",
                                width: "100%",
                              }}
                            >
                              {op.term}
                            </StyledButton>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "row",
                                color: "green",
                                fontStyle: "bold",
                              }}
                            >
                              <span>&#10003;</span>
                              <span>(Added)</span>
                            </div>
                          </div>
                        ) : (
                          <StyledButton
                            color="grey"
                            sx={{
                              color: "#000",
                              textAlign: "left",
                              justifyContent: "flex-start",
                              width: "100%",
                            }}
                            onClick={() => {
                              skipEffect.current = true; // prevent debounce call
                              optionChosen.current = true;
                              setConditionName(op.term);
                              handleChangeFamilyHistory("condition", op.term);
                            }}
                            onMouseDown={() => setMouseDownOnOption(true)}
                          >
                            {op.term}
                          </StyledButton>
                        )}
                      </div>
                    }
                  </div>
                ))}
              </>
            </div>
          ) : filteredOptions.length == 0 &&
            debounceFunctionCalledCondition &&
            !termSelectedOrAdded ? (
            <div
              style={{
                backgroundColor: "#f5f5f5",
                borderRadius: "10px",
                padding: "20px",
                maxHeight: "300px", // Set your desired maximum height here
                overflowY: "auto", // Add vertical scrolling
              }}
            >
              <div style={{ color: "red" }}>No Options Found!</div>
            </div>
          ) : null}
        </Grid>
        )}
        {fieldLayout.isFieldVisible("clinical_note", familyHistoryVars) && (
        <Grid item {...fieldLayout.getFieldGrid("clinical_note", { xs: 11, md: 11, sm: 11 })}>
          <StyledTextField
            variant="outlined"
            label={fieldLayout.getFieldLabel("clinical_note", "Clinical Notes", familyHistoryVars)}
            // multiline
            // rows={2}
            value={familyHistoryVars.clinical_note}
            onChange={(e) =>
              handleChangeFamilyHistory("clinical_note", e.target.value)
            }
            error={!!validationErrors.clinical_note}
            helperText={validationErrors.clinical_note}
            fullWidth
            InputProps={{
              endAdornment: (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ marginRight: "5px" }}>
                    <Tooltip title="Clear">
                      <OutlinedIconFab
                        size="small"
                        variant="contained"
                        onClick={handleClearClinicalNotes}
                      >
                        <Icon name="clearTextField" size={32} />
                      </OutlinedIconFab>
                    </Tooltip>
                  </div>

                  <>
                    {/* {listeningOn === false ? (
                      <Tooltip title="Start Listening">
                        <OutlinedIconFab
                          onClick={() => startListening("clinical_note")}
                          variant="contained"
                          color="defaultColor"
                          size="small"
                        >
                          <MicOffIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    ) : listeningOn === true &&
                      clinicalNotesListening === false ? (
                      <Tooltip title="Start Listening">
                        <OutlinedIconFab
                          onClick={() => startListening("clinical_note")}
                          variant="contained"
                          color="default"
                          size="small"
                        >
                          <MicOffIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Stop Listening">
                        <OutlinedIconFab
                          onClick={() => {
                            SpeechRecognition.stopListening();
                            setListeningOn(false);
                            setClinicalNotesListening(false);
                          }}
                          variant="outlined"
                          color="default"
                          size="small"
                        >
                          <KeyboardVoiceIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    )} */}
                  </>
                </div>
              ),
            }}
          />
        </Grid>
        )}
        {fieldLayout.isFieldVisible("relation", familyHistoryVars) && (
        <Grid item {...fieldLayout.getFieldGrid("relation", { xs: 11, sm: 5 })} sx={{ margin: "5px 0px", display: "flex", alignItems: "center" }}>
          <FormControl fullWidth>
            <StyledInputLabel>{fieldLayout.getFieldLabel("relation", "Select Relation", familyHistoryVars)}</StyledInputLabel>
            <StyledSelect
              value={familyHistoryVars.relation}
              onChange={(e) =>
                handleChangeFamilyHistory("relation", e.target.value)
              }
              label={fieldLayout.getFieldLabel("relation", "Select Relation", familyHistoryVars)}
            >
              {[
                "Father",
                "Mother",
                "Wife",
                "Husband",
                "Son",
                "Daughter",
                "Sister",
                "Brother",
                "Grandfather",
                "Grandmother",
                "Uncle",
                "Aunt",
                "Parents",
                "Siblings",
              ].map((relation) => (
                <MenuItem
                  key={relation}
                  value={relation}
                  sx={{ fontSize: "12px" }}
                >
                  {relation}
                </MenuItem>
              ))}
            </StyledSelect>
          </FormControl>
        </Grid>
        )}

        {fieldLayout.isFieldVisible("onSetAge", familyHistoryVars) && (
        <Grid item {...fieldLayout.getFieldGrid("onSetAge", { xs: 8, sm: 3, md: 2 })} sx={{ margin: "5px 0px", display: "flex", alignItems: "center" }}>
          <StyledTextField
            fullWidth
            label={fieldLayout.getFieldLabel("onSetAge", "On Set Age", familyHistoryVars)}
            type="number"
            value={familyHistoryVars.onSetAge ?? ""}
            onChange={(e) => {
              const value = e.target.value;
              handleChangeFamilyHistory(
                "onSetAge",
                value === "" ? "" : parseInt(value, 10)
              );
            }}
            error={!!validationErrors.onSetAge}
            helperText={validationErrors.onSetAge}
          />
        </Grid>
        )}

        {fieldLayout.isFieldVisible("deceased", familyHistoryVars) && (
        <Grid
          item
          {...fieldLayout.getFieldGrid("deceased", { xs: 6, sm: 6, md: 5 })}
          sx={{
            margin: "5px 0px",
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <FormControl
            component="fieldset"
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Typography
              variant="body1"
              sx={{ marginRight: "10px" }}
              color={"grey"}
            >
              {fieldLayout.getFieldLabel("deceased", "Deceased:", familyHistoryVars)}
            </Typography>
            <RadioGroup
              row
              aria-label="deceased"
              name="deceased"
              value={familyHistoryVars.deceased === "N/A" ? "N/A" : (familyHistoryVars.deceased ? "Yes" : "No")}
              onChange={(e) => {
                if (e.target.value === "Yes") {
                  handleChangeFamilyHistory("deceased", true);
                } else if (e.target.value === "No") {
                  handleChangeFamilyHistory("deceased", false);
                } else {
                  handleChangeFamilyHistory("deceased", "N/A");
                }
              }}
            >
              <FormControlLabel
                value="Yes"
                control={
                  <Radio
                    sx={{
                      color: "#21cdc0",
                      "&.Mui-checked": {
                        color: "#21cdc0",
                      },
                    }}
                  />
                }
                label="Yes"
              />
              <FormControlLabel
                value="No"
                control={
                  <Radio
                    sx={{
                      color: "#21cdc0",
                      "&.Mui-checked": {
                        color: "#21cdc0",
                      },
                    }}
                  />
                }
                label="No"
              />
              <FormControlLabel
                value="N/A"
                control={
                  <Radio
                    sx={{
                      color: "#21cdc0",
                      "&.Mui-checked": {
                        color: "#21cdc0",
                      },
                    }}
                  />
                }
                label="N/A"
              />
            </RadioGroup>
            {validationErrors.deceased && (
              <Typography style={{ color: "red" }}>
                {validationErrors.deceased}
              </Typography>
            )}
          </FormControl>
        </Grid>
        )}

        <Grid container item xs={12} spacing={1} alignItems="center">
          {fieldLayout.isFieldVisible("onset_duration", familyHistoryVars) && (
          <Grid
            item
            {...fieldLayout.getFieldGrid("onset_duration", { xs: 11, sm: 11, md: 5 })}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <Tooltip title="How long ago the condition started">
              <Typography
                variant="body2"
                sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
              >
                {fieldLayout.getFieldLabel("onset_duration", "Condition Onset:", familyHistoryVars)}
              </Typography>
            </Tooltip>
            <Box sx={{ flex: 1, minWidth: { xs: 0, sm: 190, md: 210 } }}>
              <DurationAutocompleteField
                label="Duration"
                value={familyHistoryVars.onset_duration || ""}
                onChange={(combined) =>
                  handleChangeFamilyHistory("onset_duration", combined)
                }
                durationType={durationType}
                error={!!validationErrors.onset_duration}
                helperText={validationErrors.onset_duration}
              />
            </Box>
          </Grid>
          )}
          {fieldLayout.isFieldVisible("abatement_duration", familyHistoryVars) && (
          <Grid
            item
            {...fieldLayout.getFieldGrid("abatement_duration", { xs: 11, sm: 11, md: 6 })}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <Tooltip title="How long the condition has been present">
              <Typography
                variant="body2"
                sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
              >
                {fieldLayout.getFieldLabel("abatement_duration", "Condition Duration:", familyHistoryVars)}
              </Typography>
            </Tooltip>
            <Box sx={{ flex: 1, minWidth: { xs: 0, sm: 190, md: 210 } }}>
              <DurationAutocompleteField
                label="Duration"
                value={familyHistoryVars.abatement_duration || ""}
                onChange={(combined) =>
                  handleChangeFamilyHistory("abatement_duration", combined)
                }
                durationType={durationType}
                error={!!validationErrors.abatement_duration}
                helperText={validationErrors.abatement_duration}
              />
            </Box>
          </Grid>
          )}

          <Grid item xs={11} sm={11} md={2} sx={{ display: "flex" }}>
            <StyledButton
              bgColor="#0E3F66"
              variant="contained"
              sx={{ width: { xs: "100%" }, marginLeft: { md: "auto" } }}
              onClick={
                familyHistoryEditIndex !== null
                  ? handleFamilyHistoryUpdate
                  : handleAddRow
              }
              color="defaultColor"
            >
              {familyHistoryEditIndex !== null ? "Update" : "Add"}
            </StyledButton>
          </Grid>
        </Grid>

        {error && <Typography style={{ color: "red" }}>{error}</Typography>}

        <Grid item xs={11} sm={11}>
          {familyHistoryData["prev"].length > 0 && (
            <StyledTableContainer
              component={Paper}
            // sx={{
            //   marginTop: "20px",
            //   border: "1px solid #21cdc0",
            // }}
            >
              <Table>
                <TableHead>
                  <StyledTableRowHistory>
                    {fieldLayout.tableColumns.map((column) => (
                      <StyledTableCellHistory key={column.key}>
                        {column.label}
                      </StyledTableCellHistory>
                    ))}
                    <StyledTableCellHistory>Action</StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableHead>
                <TableBody>
                  {familyHistoryData["prev"].map((row, rowIndex) => (
                    <StyledTableRowHistory key={rowIndex}>
                      {fieldLayout.tableColumns.map((column) => (
                        <StyledTableCellHistory key={column.key}>
                          {renderFamilyTableCell(column, row, { isPrev: true })}
                        </StyledTableCellHistory>
                      ))}
                      <StyledTableCellHistory>-</StyledTableCellHistory>
                    </StyledTableRowHistory>
                  ))}
                </TableBody>
              </Table>
            </StyledTableContainer>
          )}
        </Grid>
        <Grid item xs={11} sm={11}>
          {familyHistoryData["new"].length > 0 && (
            <StyledTableContainer
              component={Paper}
            // sx={{
            //   margin: "5px 2px",
            //   border: "1px solid #21cdc0",
            // }}
            >
              <Table>
                <TableHead>
                  <StyledTableRowHistory>
                    {fieldLayout.tableColumns.map((column) => (
                      <StyledTableCellHistory key={column.key}>
                        {column.label}
                      </StyledTableCellHistory>
                    ))}
                    <StyledTableCellHistory>Action</StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableHead>
                <TableBody>
                  {familyHistoryData["new"].map((row, rowIndex) => (
                    <StyledTableRowHistory key={rowIndex}>
                      {fieldLayout.tableColumns.map((column) => (
                        <StyledTableCellHistory key={column.key}>
                          {renderFamilyTableCell(column, row, { isNew: true })}
                        </StyledTableCellHistory>
                      ))}
                      <StyledTableCellHistory>
                        {familyHistoryData["prev"].includes(row) ? (
                          "-"
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <Tooltip title="Edit">
                              <OutlinedIconFab
                                onClick={() =>
                                  handleFamilyHistoryEditClick(row, rowIndex)
                                }
                                sx={{ marginRight: 1 }}
                              >
                                <Icon name="editInTable" size={32} />
                              </OutlinedIconFab>
                            </Tooltip>
                            <Tooltip title="Delete">
                              <OutlinedIconFab
                                onClick={() =>
                                  handleFamilyHistoryDelete(rowIndex)
                                }
                              >
                                <Icon name="deleteInTable" size={32} />
                              </OutlinedIconFab>
                            </Tooltip>
                          </div>
                        )}
                      </StyledTableCellHistory>
                    </StyledTableRowHistory>
                  ))}
                </TableBody>
              </Table>
            </StyledTableContainer>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

export default FamilyHistory;
